
/* We do not use the Redux store here because this form is only used to set the token to the local session. 
This form is indeed temporary -- a full implementation of the Cend client would integrate properly with 
an external authentication system such as SAML or OAuth. In this case, it makes a call to a simple shim
that uses the dummy authentication implemented by the reference engine code. */
import React, { Component } from "react";
import CFG from './Configconstants'
import axios from "axios";

class TempLoginForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            isVisibleMarker: true
        };    
        this.handleUsernameChange = this.handleUsernameChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }
    
    componentWillMount() {
        sessionStorage.setItem("isTempLoginFormVisible", true);
    }

    handleUsernameChange(event) {
        this.setState({username: event.target.value});
    }

    handlePasswordChange(event) {
        this.setState({password: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        var loginUrl = `${CFG.LOGINBASEURL}` + '?loginusername=' + this.state.username + '&loginpassword=' + this.state.password;
        axios.get(loginUrl)
        .then((response) => {
            sessionStorage.setItem("token", response.data.token)
            if(sessionStorage.getItem("token") === "-1"){
                sessionStorage.setItem("isTempLoginFormVisible", true);
                this.setState({isVisibleMarker: true});
                this.props.setMessageStatus("Username or Password Incorrect");
            }
            else{
                this.props.pwGetUserlist();
                this.props.pwGetSendlist();
                sessionStorage.setItem("isTempLoginFormVisible", false);
                this.setState({isVisibleMarker: false});
                this.props.tickle();
                this.props.setMessageStatus("");
            }
        })
        .catch((error) => {
            alert(error);
          });
        this.setState({username: ''});
        this.setState({password: ''});
      }

      render() {
          if((this.state.isVisibleMarker) === false) {
            return null;
          }
          else{
            return (
                <div id="loginoverlayinstance" class="loginoverlay">
                <form class="loginformcontent" onSubmit={this.handleSubmit}>
                  <label>
                    Username:
                    <input type="text" value={this.state.username} onChange={this.handleUsernameChange }/>
                  </label>
                  <label>
                    Password:
                    <input type="password" value={this.state.password} onChange={this.handlePasswordChange} />
                  </label>
                  <input type="submit" class="button" value="Login" />
                </form>
                </div>
              );
          }
      }
        
    

}

export default TempLoginForm


// WEBPACK FOOTER //
// ./src/TempLoginForm.js